import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

export const setTokens = (access, refresh) => {
  if (access) localStorage.setItem("rr_access", access);
  else localStorage.removeItem("rr_access");
  if (refresh) localStorage.setItem("rr_refresh", refresh);
  else if (refresh === null) localStorage.removeItem("rr_refresh");
};

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("rr_access");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 402) {
      if (!window.location.pathname.startsWith("/subscribe")) window.location.assign("/subscribe");
      return new Promise(() => {});
    }
    if (error.response?.status === 401 && cfg && !cfg._retry && !cfg.url.startsWith("/auth/")) {
      cfg._retry = true;
      try {
        const { data } = await api.post("/auth/refresh", null, {
          headers: { "X-Refresh-Token": localStorage.getItem("rr_refresh") || "" },
        });
        setTokens(data.access_token, data.refresh_token);
        return api(cfg);
      } catch (e) {
        setTokens(null, null);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const userTime = (r) => (r?.start_aest_iso
  ? new Date(r.start_aest_iso).toLocaleTimeString("en-AU", { hour: "2-digit", minute: "2-digit", hourCycle: "h23", timeZoneName: "short" }).toUpperCase()
  : raceTime(r));
export const raceTime = (r) => (r?.start_local ? `${r.start_local} ${r.tz}` : r?.start_aest ? `${r.start_aest} AEST` : "--:--");
export const fmtPrice = (p) => (p == null ? "—" : `$${Number(p).toFixed(2)}`);
// race pages only show today & tomorrow; asking for yesterday onwards keeps loads light
export const RECENT = () => ({ full: true, from_date: new Date(Date.now() - 86400000).toLocaleDateString("en-CA", { timeZone: "Australia/Brisbane" }) });
export const fmtNum = (v, d = 1) => (v == null ? "—" : Number(v).toFixed(d).replace(/\.0+$/, ""));

// saving vs buying monthly passes for the same number of days (6-month & annual only)
export const planSaving = (plans, p) => {
  const m = plans.find((x) => x.id === "pass_1m");
  if (!m || !["pass_6m", "pass_12m"].includes(p.id)) return 0;
  const s = (m.amount / m.days) * p.days - p.amount;
  return s >= 1 ? Math.round(s) : 0;
};

export default api;
